import React, { useEffect, useState } from "react";
import { Download, Share, Smartphone, X, ArrowUpRight } from "lucide-react";

const DISMISS_KEY = "dayone-pwa-install-dismissed";

export function PwaInstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    if (standalone || sessionStorage.getItem(DISMISS_KEY) === "1") return undefined;
    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const timer = window.setTimeout(() => {
      if (isIos) setVisible(true);
    }, 2400);
    const onPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      setVisible(true);
    };
    const onInstalled = () => setVisible(false);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible) return null;
  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };
  const install = async () => {
    if (!installEvent) {
      setShowIosHelp(true);
      return;
    }
    await installEvent.prompt();
    const choice = await installEvent.userChoice;
    if (choice.outcome === "accepted") setVisible(false);
    setInstallEvent(null);
  };

  return <aside className="site-install-card" aria-label="Installer DayOne">
    <div className="site-install-summary"><Smartphone size={20}/><div><strong>DayOne, à portée de main.</strong><span>Retrouve ta carrière sur ton écran d’accueil.</span></div><button type="button" onClick={dismiss} className="site-install-close" aria-label="Fermer l’invitation à installer"><X size={16}/></button></div>
    {showIosHelp ? <p className="site-install-help"><Share size={14}/> Sur Safari, touche <b>Partager</b>, puis <b>Sur l’écran d’accueil</b>.</p> : <button type="button" onClick={install} className="site-install-button"><Download size={14}/>Installer l’application<ArrowUpRight size={14}/></button>}
  </aside>;
}
